const actions = {
  SEARCH_LINK_BLOCK_APP_DEEP_LINKS: 'SEARCH_LINK_BLOCK_APP_DEEP_LINKS',
  SEARCH_LINK_BLOCK_APP_DEEP_LINKS_ENDED: 'SEARCH_LINK_BLOCK_APP_DEEP_LINKS_ENDED',
  CREATE_LINK_BLOCK_APP_DEEP_LINK: 'CREATE_LINK_BLOCK_APP_DEEP_LINK',
  CREATE_LINK_BLOCK_APP_DEEP_LINK_ENDED: 'CREATE_LINK_BLOCK_APP_DEEP_LINK_ENDED',
  UPDATE_LINK_BLOCK_APP_DEEP_LINK: 'UPDATE_LINK_BLOCK_APP_DEEP_LINK',
  UPDATE_LINK_BLOCK_APP_DEEP_LINK_ENDED: 'UPDATE_LINK_BLOCK_APP_DEEP_LINK_ENDED',
  GENERATE_LINK_BLOCK_APP_DEEP_LINK: 'GENERATE_LINK_BLOCK_APP_DEEP_LINK',
  GENERATE_LINK_BLOCK_APP_DEEP_LINK_ENDED: 'GENERATE_LINK_BLOCK_APP_DEEP_LINK_ENDED',
};
export default actions;
